/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { ValidationMessage, FlexRow, FlexCol } from 'sarsaparilla';
import SmartSelector from './SmartSelector';
import { IS_TRAVEL_METHOD_EMPTY } from '../../constants';
import { getValidationErrorStyle } from '../../utils/utilsNew';

export default class TravelMethod extends React.Component {
    static propTypes = {
        selectedType: PropTypes.number,
        handleTravelMethodChange: PropTypes.func,
        travelMethods: PropTypes.arrayOf(PropTypes.object),
        isExitingMtWhitney: PropTypes.bool,
        validation: PropTypes.object,
    };

    static defaultProps = {
        selectedType: 0,
        travelMethods: [],
        isExitingMtWhitney: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            focused: false,
        };
        this.convertToSelection = this.convertToSelection.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.props.handleTravelMethodChange(parseInt(event.target.value, 10));
    }

    convertToSelection(travelMethods) {
        let methods = travelMethods;
        if (methods) {
            if (this.props.isExitingMtWhitney) {
                // only include travel methods that do not involve stock
                methods = methods.filter(
                    (method) => !method.name.toLowerCase().includes('stock')
                );
            }
            return methods.map((method) => {
                return { value: method.type.toString(), label: method.name };
            });
        }
        return [];
    }

    render() {
        const validationHighlight = getValidationErrorStyle(
            this.props.validation,
            IS_TRAVEL_METHOD_EMPTY
        );
        return (
            <div className="per-travel-method-form per-section-group">
                <div className="rec-order-detail-subsection-title">Travel Method</div>
                <p>Please select the type of travel you will be using on this trip.</p>
                <FlexRow>
                    <FlexCol md={6}>
                        <div className="rec-form-item-wrap">
                            <SmartSelector
                                label="Travel Method"
                                className={validationHighlight}
                                options={this.convertToSelection(
                                    this.props.travelMethods
                                )}
                                name="travel-method"
                                id="travel-method"
                                isRequired
                                value={this.props.selectedType.toString()}
                                handleChange={this.handleChange}
                                placeholderOption={{
                                    value: '0',
                                    label: 'Select from list',
                                }}
                            />
                            {validationHighlight && (
                                <ValidationMessage
                                    controlName="Travel Method"
                                    message="is required."
                                />
                            )}
                        </div>
                    </FlexCol>
                </FlexRow>
            </div>
        );
    }
}
